export default "__VITE_ASSET__CVqvCVgk__"